import { useEffect } from "react"
import PropTypes from "prop-types"
import imageCompression from "browser-image-compression"

function CaptureImage({ setImage, image, open }) {
  useEffect(() => {
    if (open) setImage(null)
  }, [open])

  const handleFileChange = async (event) => {
    const file = event.target.files[0] // Get the selected file

    if (file) {
      const options = {
        maxSizeMB: 1, // Max image size in MB
        maxWidthOrHeight: 1920, // Max width/height of the image
      }

      try {
        const compressedFile = await imageCompression(file, options)
        const reader = new FileReader()

        reader.onloadend = () => {
          const base64Image = reader.result
          setImage(base64Image)
        }

        reader.readAsDataURL(compressedFile) // Read the compressed image as Base64
      } catch (error) {
        console.error("Error compressing image:", error)
      }
    }

    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader()

      reader.readAsDataURL(file) // Read the file as a Data URL (Base64 string)
    } else {
      console.error("Please select a valid image file.")
    }
  }

  return (
    <div>
      <input
        type='file'
        accept='image/*' // Limit file selection to images only
        onChange={handleFileChange}
      />

      {image && (
        <div>
          <h4>Image Preview:</h4>
          <img src={image} alt='Selected' style={{ width: "200px" }} />
        </div>
      )}
    </div>
  )
}

// Define the prop types
CaptureImage.propTypes = {
  setImage: PropTypes.func.isRequired,
  image: PropTypes.string,
}

// Default props

export default CaptureImage
